import React from 'react';
import { CircularProgress } from '@mui/material';


function Spinner(props) {
    return (
        <div className={"progress_wrapper"}>
            <CircularProgress/>
        </div>
    );
}

export default Spinner;